import React, { SVGProps } from 'react';

const SvgLogout = (props: SVGProps<SVGSVGElement>) => {
	return (
		// <svg
		// 	xmlns='http://www.w3.org/2000/svg'
		// 	height='1em'
		// 	viewBox='0 0 24 24'
		// 	width='1em'
		// 	fill='currentColor'
		// 	className='svg-icon'
		// 	{...props}>
		// 	<path d='M0 0h24v24H0V0z' fill='none' />
		// 	<path d='M5 5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V5zm16 7l-4-4v3H9v2h8v3l4-4z' />
		// </svg>
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.4291 8.62169C17.3345 8.52712 17.3345 8.43254 17.2399 8.33797L14.4027 5.50069C14.0244 5.12239 13.4569 5.12239 13.0786 5.50069C12.7003 5.879 12.7003 6.44645 13.0786 6.82475L14.3081 8.05424H9.9576C9.39014 8.05424 9.01184 8.43254 9.01184 9C9.01184 9.56745 9.39014 9.94576 9.9576 9.94576H14.3081L13.0786 11.1752C12.7003 11.5535 12.7003 12.121 13.0786 12.4993C13.2678 12.6885 13.5515 12.783 13.7406 12.783C13.9298 12.783 14.2135 12.6885 14.4027 12.4993L17.2399 9.66203C17.3345 9.56745 17.4291 9.47288 17.4291 9.3783C17.5237 9.09457 17.5237 8.90542 17.4291 8.62169Z" fill="black"/>
<path d="M12.322 14.7691C11.2816 15.3366 10.1467 15.6203 9.01182 15.6203C5.32337 15.6203 2.39152 12.6885 2.39152 9C2.39152 5.31154 5.32337 2.37969 9.01182 2.37969C10.1467 2.37969 11.2816 2.66342 12.322 3.23087C12.7949 3.5146 13.3623 3.32545 13.646 2.85257C13.9298 2.37969 13.7406 1.81224 13.2677 1.52851C11.9437 0.866478 10.525 0.488174 9.01182 0.488174C4.28303 0.488174 0.5 4.27121 0.5 9C0.5 13.7288 4.28303 17.5118 9.01182 17.5118C10.525 17.5118 11.9437 17.1335 13.2677 16.3769C13.7406 16.0932 13.8352 15.5257 13.646 15.0528C13.3623 14.6745 12.7949 14.4854 12.322 14.7691Z" fill="black"/>
</svg>
	);
}

export default SvgLogout;
